function _instanceof(left, right) {
  return null != right && "undefined" != typeof Symbol && right[Symbol.hasInstance] ? right[Symbol.hasInstance](left) : left instanceof right;
}

function _typeof(obj) {
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [],
      _n = !0,
      _d = !1,
      _e = void 0;

  try {
    for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i && _arr.length === i)); _n = !0) {
      ;
    }
  } catch (err) {
    _d = !0, _e = err;
  } finally {
    try {
      _n || null == _i["return"] || _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(target, props) {
  for (var descriptor, i = 0; i < props.length; i++) {
    descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
}

function _possibleConstructorReturn(self, call) {
  return call && ("object" === _typeof(call) || "function" == typeof call) ? call : _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self;
}

function _inherits(subClass, superClass) {
  if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: !0,
      configurable: !0
    }
  }), superClass && _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  return _setPrototypeOf = Object.setPrototypeOf || function (o, p) {
    return o.__proto__ = p, o;
  }, _setPrototypeOf(o, p);
}

import { createElement } from "react";
import PropTypes from "prop-types";
import BaseControl from "./base-control";

var propTypes = Object.assign({}, BaseControl.propTypes, {
  className: PropTypes.string,
  longitude: PropTypes.number.isRequired,
  latitude: PropTypes.number.isRequired,
  offsetLeft: PropTypes.number,
  offsetTop: PropTypes.number
}),
    defaultProps = Object.assign({}, BaseControl.defaultProps, {
  className: "",
  offsetLeft: 0,
  offsetTop: 0
}),
    Marker = function (_BaseControl) {
  function Marker() {
    return _classCallCheck(this, Marker), _possibleConstructorReturn(this, (Marker.__proto__ || Object.getPrototypeOf(Marker)).apply(this, arguments));
  }

  return _inherits(Marker, _BaseControl), _createClass(Marker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          longitude = _this$props.longitude,
          latitude = _this$props.latitude,
          offsetLeft = _this$props.offsetLeft,
          offsetTop = _this$props.offsetTop,
          _this$context$viewpor = this.context.viewport.project([longitude, latitude]),
          _this$context$viewpor2 = _slicedToArray(_this$context$viewpor, 2),
          x = _this$context$viewpor2[0],
          y = _this$context$viewpor2[1];

      return createElement("div", {
        className: "mapboxgl-marker ".concat(className),
        ref: this._onContainerLoad,
        style: {
          position: "absolute",
          left: x + offsetLeft,
          top: y + offsetTop
        },
        children: this.props.children
      });
    }
  }]), Marker;
}(BaseControl);

export { Marker as default };
Marker.displayName = "Marker", Marker.propTypes = propTypes, Marker.defaultProps = defaultProps;